<template>
  <div class="sn-f-b-s homepage">
    <sn-navigator id="JZRGL"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s homepage-region">
      <sn-breadcrumb :breadcrumb="[{ title: '就诊人管理' }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 homepage-blank">
        <div class="abnormal" v-if="isShowRefresh">
          <div class="explain">{{noMessage}}</div>
          <div class="sn-f-c-c switch-btn">
            <div class="sn-f-c-c btn" @click="initial();">刷新</div>
          </div>
        </div>
        <template v-else>
          <div class="sn-f-e-c top-blank">
            <div class="main5Color-content">
              {{patientArray.length < patientStandard ? '您最多添加' + patientStandard + '位就诊人，您已添加' + patientArray.length + '位，还可添加' + (patientStandard - patientArray.length) + '位' : '添加就诊人已达上限，请删除后添加'}}
            </div>
            <el-button v-if="patientArray.length < patientStandard" type="primary" @click="navigateUrl('addition-patient');">添加就诊人</el-button>
          </div>
          <div class="sn-table" v-if="!$sn.validate.empty(patientArray)">
            <table>
              <thead>
                <tr>
                  <th>当前就诊人</th>
                  <th>姓名</th>
                  <th>证件号</th>
                  <th>手机号</th>
                  <th>性别</th>
                  <th v-if="![perpetual.HOSPITAL_ID_SDSL].includes($sn.utils.getHospitalId())">就诊卡</th>
                  <th v-if="isOpenInCardManage">住院号</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="patient.patientId" v-for="patient in patientArray">
                  <td class="sn-f-s-c">
                    <div class="iconfont" :class="patient.defaultState === '1' ? 'sn-fc-main icon-a-jianqu5' : 'sn-fc-text6 icon-fangkuangweixuanzhong'" @click="setUpDefaultClick(patient);"></div>
                    <div v-if="patient.defaultState === '1'" class="sn-ph-10">当前就诊人</div>
                  </td>
                  <td>{{ $sn.encrypted.name(patient.patientName) }}</td>
                  <td>{{ patient.idCardType === '0' ? $sn.encrypted.idCardSerial(patient.patientIdCardNo) : patient.idCardEncrypt }}</td>
                  <td>{{ patient.phoneEncrypt }}</td>
                  <td>{{ $sn.format.sex(patient.patientSex) }}</td>
                  <td v-if="![perpetual.HOSPITAL_ID_SDSL].includes($sn.utils.getHospitalId())">
                    <div class="sn-f-b-c">
                      <div class="sn-omit" :style="{'max-width': $sn.validate.empty(patient.outCardCaption) ? '100%' : '100px'}" v-if="patient.outCardCaption">{{ patient.outCardCaption }}</div>
                      <div class="sn-fc-main sn-pointer sn-omit" :style="{'max-width': $sn.validate.empty(patient.outCardCaption) ? '100%' : '100px'}" :class="{'marginLeft10Horizontal-blank': patient.outCardCaption && patient.outButtonDescription}"
                      v-if="patient.outButtonDescription" @click="clinicType = perpetual.OUT_CARD_CLINIC_TYPE; navigateUrl('addition-card', patient)">{{ patient.outButtonDescription }}</div>
                    </div>
                  </td>
                  <td v-if="isOpenInCardManage">
                    <div class="sn-f-b-c">
                      <div class="sn-omit" :style="{'max-width': $sn.validate.empty(patient.inCardCaption) ? '100%' : '100px'}" v-if="patient.inCardCaption">{{ patient.inCardCaption }}</div>
                      <div class="sn-fc-main sn-pointer sn-omit" :style="{'max-width': $sn.validate.empty(patient.inCardCaption) ? '100%' : '100px'}" :class="{'marginLeft10Horizontal-blank': patient.inCardCaption && patient.inButtonDescription}"
                      v-if="patient.inButtonDescription" @click="clinicType = perpetual.IN_CARD_CLINIC_TYPE; navigateUrl('addition-card', patient)">{{ patient.inButtonDescription }}</div>
                    </div>
                  </td>
                  <td>
                    <div class="sn-f-c-c" :class="{'sn-f-s-c': [perpetual.HOSPITAL_ID_SDSL].includes($sn.utils.getHospitalId())}">
                      <div class="sn-fc-main sn-pointer" @click="deleteClick(patient)">删除</div>
                      <div class="sn-fc-main sn-pointer" :class="[perpetual.HOSPITAL_ID_SDSL].includes($sn.utils.getHospitalId()) ? 'sn-ph-10' : 'marginLeft10Horizontal-blank'" @click="navigateUrl('addition-patient', patient)">编辑</div>
                      <div class="sn-fc-main sn-pointer" v-if="[perpetual.HOSPITAL_ID_SDSL].includes($sn.utils.getHospitalId())" @click="clinicType = perpetual.OUT_CARD_CLINIC_TYPE; navigateUrl('addition-card', patient);">身份绑定</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <sn-no-data v-else></sn-no-data>
        </template>
      </div>
    </div>
    <create-patient v-if="functionCondition === 'patient'" :patientId="selectPatientId" @sendBack="sendBack"></create-patient>
    <bind-card v-if="functionCondition === 'card'" :type="clinicType" :patientId="selectPatientId" @sendBack="sendBack"></bind-card>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import self from '@/common/utils/global-config';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import * as ServiceConfig from '@/common/utils/service-config';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';

export default {
  mixins: [PatientShareMixin],
  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  data() {
    return {
      patientArray: [],
      functionCondition: '',
      selectPatientId: '',
      clinicType: '', // 就诊类型
      patientStandard: self.$sn.getConfig('patientStandard'), // 就诊人最大数量
      isOpenCardManage: self.$sn.getConfig('isOpenCardManage'), // 是否开通就诊卡管理
      isOpenInCardManage: false, // 是否开通住院
      isShowRefresh: false, // 显示刷新按钮
      noMessage: Messages.C008
    };
  },
  computed: {},
  watch: {},
  created: function() {
    this.initial();
  },
  methods: {
    async initial() {
      this.isOpenInCardManage = this.$sn.utils.isOpenFunction(this.perpetual.FUNCTION_ID_ZYRGL);
      this.isShowRefresh = false;
      this.$sn.assembly.loading(true);
      const result = await Initial.obtainPatientInfoByCondition(true);
      this.$sn.assembly.loading(false);
      if (result && result.code === 0) {
        // 检查 result 是否为非空数组
        if (this.$sn.validate.array(result.data) && result.data.length > 0) this.formatInfo(result.data);
        else this.patientArray = [];
      }
      else {
        this.isShowRefresh = true;
        this.patientArray = [];
      }
    },
    // 根据当前账号获取患者信息
    async formatInfo(result) {
      // 对每个患者信息进行处理，同时获取 门诊 or 住院卡信息
      this.patientArray = await Promise.all(result.map(async patient => {
        patient.defaultState = this.$sn.utils.getCurrentPatient()?.patientId === patient.patientId ? '1' : '0';
        // 处理门诊卡信息
        const outCardInfo = await this.handleCardInfo(patient);
        // 处理住院卡信息
        const inCardInfo = await this.handleCardInfo(patient, this.perpetual.IN_CARD_CLINIC_TYPE);
        // 返回包含扩展信息的患者信息
        return {
          ...patient,
          ...outCardInfo,
          ...inCardInfo
        };
      }));
    },
    // 处理卡信息
    async handleCardInfo(patient, clinicType = this.perpetual.OUT_CARD_CLINIC_TYPE) {
      let flag = true;
      if (!this.isOpenCardManage) {
        if (clinicType === this.perpetual.IN_CARD_CLINIC_TYPE) flag = false;
      }
      const handle = await Tools.handlePatientInfo(patient, clinicType, flag);
      let cardCaption = handle.code >= 0 && !handle.data.caption.includes('需重新绑定') ? handle.data.caption : '';
      let buttonDescription = this.generateButtonDescription(handle.data.no, handle.data.caption, '未绑卡', '切换', '绑定');
      if (clinicType === this.perpetual.OUT_CARD_CLINIC_TYPE) {
        if (!this.isOpenCardManage) {
          if (handle.code >= 0 && handle.data.no) buttonDescription = '';
          else {
            if (this.$sn.utils.isOpenFunction(this.perpetual.FUNCTION_ID_ZXJD)) buttonDescription = '在线建档';
            else buttonDescription = '';
          }
        }
      }
      else if (clinicType === this.perpetual.IN_CARD_CLINIC_TYPE) {
        if (handle.code >= 0 && !handle.data.caption.includes('需重新绑定')) {
          cardCaption = handle.data.caption === '此就诊人未建档' ? '未绑卡' : handle.data.caption;
        }
        else cardCaption = '';
        if (this.$sn.validate.empty(this.generateButtonDescription(handle.data.no, handle.data.caption, '未绑卡', '切换', '绑定'))) buttonDescription = '绑定';
      }
      return {
        [`${clinicType === this.perpetual.OUT_CARD_CLINIC_TYPE ? 'out' : 'in'}CardCaption`]: cardCaption,
        [`${clinicType === this.perpetual.OUT_CARD_CLINIC_TYPE ? 'out' : 'in'}ButtonDescription`]: buttonDescription
      };
    },
    // 生成按钮的描述文本
    // @param {number|string} no - 卡号 {string} caption - 按钮的当前文本
    // @param {string} unBindText - 解绑状态时的按钮文本 {string} switchText - 切换状态时的按钮文本 {string} bindText - 绑定状态时的按钮文本
    // @returns {string} 根据条件返回相应的按钮描述文本，否则返回空字符串
    generateButtonDescription(no, caption, unBindText, switchText, bindText) {
      // 当有卡号且当前文本不为空时，返回切换状态的文本
      if (no && caption) return caption.includes('需重新绑定') ? caption : switchText;
      // 当卡号为空，且当前文本与解绑文本相同时，返回绑定状态的文本
      else if (this.$sn.validate.empty(no) && caption && caption === unBindText) return bindText;
      // 其他情况返回空字符串
      return '';
    },
    // 设置默认就诊人
    setUpDefaultClick(patient) {
      this.patientArray.forEach(item => {
        if (item.patientId === patient.patientId) {
          item.defaultState = '1';
          Tools.modifyPatientInfo(patient.patientId, { defaultState: '1' });
        }
        else item.defaultState = '0';
        return item;
      });
    },
    // 删除就诊人
    deleteClick(info) {
      // captionConfirm: '确定按钮文案' captionCancel: '取消按钮文案' title: '标题' caption: '展示文本' isConfirm: true(是否显示确定按钮) true(是否显示取消按钮)
      this.$sn.assembly.modal({
        caption: Messages.PATIENT028,
        success: (modal) => {
          if (modal.confirm) {
            const params = {
              url: Swagger.deletePatientInfo,
              query: {
                patientId: info.patientId,
                hosId: this.$sn.utils.getHospitalId(),
                bindType: this.$sn.utils.getPlatformType(),
                openId: this.$sn.utils.getOpenId()
              },
              method: 'PUT',
              header: true
            };
            this.$sn.assembly.loading(true);
            this.$sn.utils.ordinaryRequest(params, ServiceConfig.deletePatientInfoComplete, '', {
              id: info.patientId
            }).then(result => {
              this.$sn.assembly.loading(false);
              if (result && result.code === 0) {
                this.$sn.assembly.toast({
                  caption: this.$sn.format.caption(Messages.C016, ['删除就诊人']),
                  success: () => {
                    this.initial();
                  }
                });
              }
              else this.$sn.assembly.toast({ caption: result && result.msg ? result.msg : Messages.C001 });
            });
          }
        }
      });
    },
    // 添加就诊人/绑卡组件回调
    sendBack(type) {
      if (type) this.initial();
      this.functionCondition = '';
    },
    // 跳转页面
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (['addition-patient', 'addition-card'].includes(url)) {
        this.selectPatientId = item?.patientId || '';
        const functionCondition = {
          'addition-patient': 'patient',
          'addition-card': 'card'
        };
        this.functionCondition = functionCondition[url];
      }
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.homepage {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    height: 100%;

    .homepage-blank {
      overflow: hidden;
      width: 100%;
      padding: 20px 20px 0;

      .top-blank {
        margin-bottom: 10px;

        .main5Color-content {
          color: $main5;
        }
      }

      .el-button {
        padding: 10px 15px;
        margin-left: 10px;
        background-color: $main1;
        border-color: $main1;
      }

      .marginLeft10Horizontal-blank {
        margin-left: 10px;
      }
    }

    .abnormal {
      @include fs(16);

      background-color: $transparent;
      padding: 100px 30px 10px;
      text-align: center;

      .explain {
        color: $text6;
      }

      .switch-btn {
        margin-top: 30px;

        .btn {
          width: 200px;
          height: 60px;
          border-radius: 30px;
          background-color: $main;
          color: $white;
        }
      }
    }
  }
}
</style>
